import angular from "angular";
import $ from 'jquery';
import 'metismenu';

angular
    .module('sentinel.gateway.web')
    .controller('SentinelUiController', SentinelUiController);

////////////////////////////
SentinelUiController.$inject = ['$rootScope'];

function SentinelUiController($rootScope) {
    var vm = {};
    init();
    return vm;

    function init() {
        angular.element(document).ready(function () {
            $('#menu').metisMenu();
        });
    }
}
